var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parameter"},[_c('div',{staticClass:"caption grey--text",class:{ 'text-uppercase': _vm.uppercaseLabel}},[_vm._v(_vm._s(_vm.label)+":")]),_c('div',{staticClass:"font-weight-bold",class:{ 'body-2': _vm.small }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }